import React from 'react';
import { Link } from 'react-router-dom';
import MuiLink from '@material-ui/core/Link';

const BASE_URL = process.env.REACT_APP_BASE_APP_URL;
const ORDERS_APP_ORIGIN = BASE_URL.replace('{app}', 'orders');

export const orderFormatter = (cell, row) => {
  const isSameOrigin = window.location.origin === ORDERS_APP_ORIGIN;

  if (isSameOrigin) {
    return (
      <MuiLink variant="subtitle1" component={Link} to={`/orders/${row.id}`}>
        {row.number || '-'}
      </MuiLink>
    );
  }

  return (
    <MuiLink variant="subtitle1" href={`${ORDERS_APP_ORIGIN}/orders/${row.id}`}>
      {row.number || '-'}
    </MuiLink>
  );
};

export default orderFormatter;
